import { mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivPurchasedRoot = styled.div`
  position: relative;
  overflow: auto;
  max-height: 800px;
  margin: 32px 0px;

  ${mq.sp} {
    margin: 16px 0px;
    max-height: 560px;
  }
`;

export const DivLoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  overflow: hidden;

  width: 100%;
  padding-bottom: 32px;
  ${mq.sp} {
    padding-bottom: 16px;
  }
`;
